import React from "react";
import { useKnockFeed } from "../KnockFeedProvider";
export var EmptyFeed = () => {
  var {
    colorMode
  } = useKnockFeed();
  return /*#__PURE__*/React.createElement("div", {
    className: "rnf-empty-feed rnf-empty-feed--".concat(colorMode)
  }, /*#__PURE__*/React.createElement("div", {
    className: "rnf-empty-feed__inner"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "rnf-empty-feed__header"
  }, "No notifications yet"), /*#__PURE__*/React.createElement("p", {
    className: "rnf-empty-feed__body"
  }, "We'll let you know when we've got something new for you.")));
};
//# sourceMappingURL=EmptyFeed.js.map